import { Inject, Injectable } from '@angular/core';
import { TMachineMaintenanceEnvironmentVars } from '@monorepo/types';

const MachineMaintenanceEndPoints = {
  //common Excel APIS
  DOWNLOAD_SAMPLE_TEMPLATE_URL: '/api/v1/excel/generateTemplate/:excelContext/:factoryId',
  UPLOAD_FILE_URL: '/api/v1/excel/uploadFile',
  DOWNLOAD_ERROR_SHEET_URL: '/api/v1/excel/downloadErrorSheet?key=errorFileKey',
  DOWNLOAD_LISTING_DATA: '/api/v1/downloadListingData/:context',

  //Machine Listing APIs
  FETCH_MACHINE_LIST_DATA: '/api/v1/machine/list',
  MACHINE_LIST_FILTER_DROPDOWN_VALUES: '/api/v1/machine/dropdown/:factoryId',
  DELETE_MACHINES: '/api/v1/machine/delete',
  UPDATE_MACHINE: '/api/v1/machine/update',
  BULK_UPDATE_MACHINE_STATUS: '/api/v1/machine/updateStatus',
  BULK_UPDATE_MACHINE_QR_PRINTED_STATUS: '/api/v1/machine/updateQRStatus',
  GET_LOCATIONS_FOR_NEW_MACHINES: '/api/v1/getLocationsForNewMachines/:factoryId',
  ADD_MACHINE_LOCATION: '/api/v1/machine/addLocation',
  GET_MACHINE_TRANSFER_DETAILS: '/api/v1/machine/getTransferDetails',
  TRANSFER_MACHINE_TO_EXTERNAL_LOCATION: '/api/v1/machine/transfer',
  GET_MACHINE_AND_LOCATION_DETAILS: '/api/v1/machine/machineAndLocationDetails',
  GET_SIBLING_FACTORIES: '/api/v1/machine/transfer/toSiblingFactory/details',
  TRANSFER_MACHINE_TO_SIBLING_FACTORY: '/api/v1/machine/transfer/toSiblingFactory',
  TRANSFER_MACHINE_BETWEEN_FLOATING_AREAS: '/api/v1/machine/transfer/betweenFloatingAreas',
  BULK_UPDATE_PREVENTIVE_SCHEDULE: '/api/v1/machine/update/preventiveLastScheduledAt',
  RETURN_MACHINES_TO_VENDOR: '/api/v1/machine/returnToVendor',
  REACTIVATE_RETURNED_MACHINES: '/api/v1/machine/reactivateReturned',
  GET_MACHINES_BY_SERIAL_NUMBER: '/api/v1/machine/machinesBySerialNumber',

  //SpartPart Listing APIs
  FETCH_SPAREPART_LIST_DATA: '/api/v1/sparePart/list',
  DELETE_SPAREPART: '/api/v1/sparePart/delete',
  UPDATE_SPAREPART: '/api/v1/sparePart/update',

  //SparePart Request APIs
  FETCH_SPAREPART_REQUEST_LIST_DATA: '/api/v1/sparePart/request/list',
  UPDATE_SPAREPART_REQUEST_STATUS: '/api/v1/sparePart/request/update',
  SPAREPART_REQUEST_PARTIAL_APPROVE: '/api/v1/sparePart/request/approve',
  BULK_UPDATE_SPAREPART_THRESHOLD: '/api/v1/sparePart/update/threshold',
  BULK_UPDATE_SPAREPART_CRITICAL: '/api/v1/sparePart/update/isCritical',
  GET_ALL_BRANDS_AND_SPECIFICATIONS_BY_NAME: '/api/v2/sparePart/getBrandsAndSpecificationsByName',

  //Needle List APIs
  FETCH_NEEDLE_LIST_DATA: '/api/v1/needle/list',
  NEEDLE_LIST_DROPDOWN_VALUES: '/api/v1/needle/dropdown',
  UPDATE_NEEDLE: '/api/v2/needle/update',
  DELETE_NEEDLE: '/api/v2/needle/delete',
  RAISE_NEEDLE_REQUEST: '/api/v2/needle/request/createForLocalStores',
  GET_BRAND_AND_TYPE_BY_NEEDLE_NUMBER: '/api/v1/needle/getBrandsAndTypesByNeedleNumber',

  //Config Setup APIs
  FETCH_HOLIDAY_LIST: '/api/v1/factoryConfig/holidays/list',
  ADD_HOLIDAYS: '/api/v1/factoryConfig/holidays/add',
  DELETE_HOLIDAYS: '/api/v1/factoryConfig/holidays/delete',
  EDIT_HOLIDAYS: '/api/v1/factoryConfig/holidays/update',

  //Employee Management APIs
  FETCH_EMPLOYEE_LIST: '/api/v1/employee/list',
  DELETE_EMPLOYEE: '/api/v1/employee/delete',
  UPDATE_EMPLOYEE: '/api/v2/employee/update',
  GET_ASSIGNABLE_SHIFTS_FOR_EMPLOYEE: '/api/v1/factoryShift/getAssignableShiftsForEmployee',
  GET_EMPLOYEE_REPLACEMENT: '/api/v2/employee/getEmployeeReplacements',
  GET_EMPLOYEE_REPLACEMENT_FOR_MAINTENANCE_TICKETS: '/api/v1/employee/getEmployeeReplacementsForTicket',
  GET_EMPLOYEE_REPLACEMENT_FOR_TICKETS: '/api/v3/employee/getEmployeeReplacementsForTicket',
  GET_ISSUE_CATEGORIES_AND_MACHINE_TYPE_DROPDOWN_INFO: '/api/v1/factoryConfig/getIssueCategoriesAndMachineTypes',

  //Mechanic Dashboard APIs
  FETCH_MECHANIC_DASHBOARD: '/api/v1/employee/loginActivityDashboard',

  //Location Management APIs
  FETCH_LOCATION_LIST: '/api/v1/location/list',
  DELETE_LOCATION: '/api/v1/location/delete',
  GET_EMPLOYEES_BY_LOCATION_IDS: '/api/v2/employee/getEmployeesByLocationIds',
  ADD_EMPLOYEES: '/api/v1/location/addEmployees',
  GET_FLOATING_AREAS: '/api/v1/location/getFloatingAreas/:factoryId',
  GET_LOCAL_NEEDLE_STORES: '/api/v1/location/getNeedleRequestRoutes',
  ASSIGN_NEEDLE_STORES: '/api/v1/location/addNeedleRequestRoutes',

  //Breakdown Reason APIs
  FETCH_BREAKDOWN_REASONS_LIST: '/api/v1/breakdownReasons/list',
  BREAKDOWN_REASONS_FILTER_DROPDOWN: '/api/v1/breakdownReasons/dropdown/:factoryId',
  DELETE_BREAKDOWN_REASONS: '/api/v1/breakdownReasons/delete',
  UPDATE_BREAKDOWN_REASONS: '/api/v1/breakdownReasons/bulkUpdate',

  //Machine Service APIs
  MACHINE_SERVICE_LIST: '/api/v1/maintenanceSchedule/list',
  UPDATE_MACHINE_SERVICE_TASKS: '/api/v1/maintenanceSchedule/bulkUpdate',

  //Needle Request APIs
  GET_NEEDLE_REQUEST_LIST: '/api/v1/needle/request/list',
  GET_LOCAL_STORE_REQUESTS: '/api/v1/needle/localStoreRequests',
  BULK_NEEDLE_REQUEST_UPDATE: '/api/v1/needle/request/update',
  APPROVE_NEEDLE_REQUEST: '/api/v2/needle/request/approve',

  //Line-setup APIs
  ADD_WORKSTATION: '/api/v3/workstation/add',
  GET_ALL_WORKSTATIONS: '/api/v1/workstation/getAllWorkstations/:factoryId/:locationId',
  ASSIGN_MACHINE_TO_WORKSTATION: '/api/v3/workstation/addMachine',
  REMOVE_MACHINE_FROM_WORKSTATION: '/api/v3/workstation/removeMachine',
  REPLACE_MACHINE_IN_WORKSTATION: '/api/v1/workstation/replaceMachine',
  REMOVE_WORKSTATION: '/api/v3/workstation/remove',
  RESET_PRODUCTION_AREA: '/api/v1/workstation/resetProductionArea',
  GET_FACTORY_LINE_WORKSTATION_SUMMARY_LIST: '/api/v1/location/getAllFactoryLineWorkstationSummary/:factoryId',
  GET_ALL_LINES_FOR_FACTORY: '/api/v1/location/getAllLineLocations/:factoryId',
  UPDATE_MACHINE_NEEDLES: '/api/v1/machine/updateNeedles',
  SEARCH_NEEDLE_NUMBERS: '/api/v1/needle/searchNeedleNumbers',
  ADD_MACHINE_NEEDLES: '/api/v2/machine/addNeedles',
  REMOVE_MACHINE_NEEDLES: '/api/v2/machine/removeNeedles',
  GET_BRANDS_AND_TYPES_BY_NEEDLE_NUMBER: '/api/v1/needle/getBrandsAndTypesByNeedleNumber',
  LINE_SETUP_TICKET_LISTING: '/api/v1/line/ticket/list',
  LINE_SETUP_TICKET_DETAILS: '/api/v1/line/ticket/details/:lineSetupTicketId',
  LINE_SETUP_TICKET_DELETE: '/api/v1/line/ticket/delete',
  LINE_SETUP_TICKET_UPDATE_MECHANIC: '/api/v1/line/ticket/updateMechanic',
  LINE_SETUP_TICKET_UPDATE: '/api/v1/line/ticket/update',
  LINE_SETUP_TICKET_SUBTASK_CREATE: '/api/v1/line/ticket/subTask/create',
  LINE_SETUP_TICKET_SUBTASK_DELETE: '/api/v1/line/ticket/subTask/delete',
  LINE_SETUP_TICKET_SUBTASK_LIST: '/api/v1/line/ticket/subTask/list',
  GET_ALL_ASSIGNED_MECHANICS_FOR_LOCATION: '/api/v1/location/assignedMechanic/:locationId',
  GET_FLOATING_AREA_MCHINES_BY_LOCATION: '/api/v1/machine/floatingArea/:locationId',

  //ticket-management APIs
  GET_BREAKDOWN_REASON_SOLUTION_LIST: '/api/v1/breakdownReasons/getReasonAndSolutionDropdownByMachine',
  CREATE_NEW_TICKET: '/api/v1/machineTicket/create',
  ASSIGN_TICKET_TO_ME: '/api/v1/machineTicket/createAndAssignToUser',
  UPDATE_ISSUE: '/api/v1/machineTicket/updateMachineIssue',
  REASSIGN_MECHANIC: '/api/v2/machineTicket/reassignMechanic',
  REIUSSE_TICKET: '/api/v1/machineTicket/reissue/:factoryId/:ticketId',
  APPROVE_TICKET: '/api/v1/machineTicket/approve/:factoryId/:ticketId',
  PICKUP_TICKET: '/api/v1/machineTicket/pickup/:factoryId/:ticketId',
  MARK_TICKET_COMPLETED: '/api/v1/machineTicket/markCompleted/:factoryId/:ticketId',
  GET_ALL_EMPLOYEE_TICKETS: '/api/v7/machineTicket/getAllEmployeeTickets',

  GET_EMPLOYEE_TICKET_DETAILS: '/api/v1/machineTicket/getTicketDetailsById',
  GET_MACHINE_TICKET_HISTORY: '/api/v3/machineTicket/getMachineTicketHistory',
  GET_MACHINE_MAINTENANCE_HISTORY: '/api/v1/maintenanceTicket/getMachineTicketHistory',
  EMPLOYEE_TICKET_SUMMARY: '/api/v2/machineTicket/getEmployeeTicketSummary',
  TICKET_SUMMARY_ANALYTICS: '/api/v1/machineTicket/getEmployeeTicketAnalytics',
  GET_FACTORY_SHIFT_REVISION: '/api/v2/factoryShift/getShiftDetails',
  ADD_SHIFT_REVISIONS: '/api/v3/factoryShift/addRevisions',
  GET_LOCATION_SHIFTS: '/api/v1/factoryShift/getLocationShifts',
  UPDATE_SHIFT_REVISION: '/api/v2/factoryShift/updateRevision',
  DELETE_SHIFT_REVISION: '/api/v1/factoryShift/deleteRevision/:shiftRevisionId',

  // Maintenance Ticket Management APIs
  GET_ALL_MAINTENANCE_TICKETS: '/api/v5/maintenanceTicket/list',
  CREATE_MAINTENANCE_TICKET: '/api/v2/maintenanceTicket/create',
  START_MAINTENANCE_TICKET: '/api/v1/maintenanceTicket/start',
  COMPLETE_MAINTENANCE_TICKET: '/api/v1/maintenanceTicket/complete',
  REASSIGN_MAINTENANCE_MECHANIC: '/api/v1/maintenanceTicket/reassignMechanic',
  MARK_CHECKLIST_COMPLETED: '/api/v1/maintenanceTicket/markChecklistCompleted',

  //SparePart-ticket APIs
  SPAREPART_SEARCH_NAMES: '/api/v1/sparePart/searchNames',
  CREATE_SPAREPART_REQUEST: '/api/v3/sparePart/request/create',
  GET_SPAREPART_REQUEST_BY_SOURCE: '/api/v3/sparePart/request/getRequestsBySource',
  CANCEL_SPAREPART_REQUEST: '/api/v1/sparePart/request/cancel/:requestId',
  GET_SPAREPART_REQUEST_REASONS: '/api/v1/sparePart/request/getReasons/:sparePartType',

  // Npt APIs
  GET_LINES_WITH_NPT: '/api/v1/npt/getLineWithNPT',
  GET_WORKSTATIONS_WITH_NPT: '/api/v1/npt/getWorkstationNPTDetails',
  GET_WORKSTATION_NPTS: '/api/v1/npt/getWorkstationNPTs',
  CREATE_NPT: '/api/v1/npt/create',
  GET_FACTORY_LEVEL_NPTS: '/api/v1/npt/listFactoryLevelNPT',
  CREATE_BULK_NPT: '/api/v1/npt/bulkCreate',
  CREATE_NPT_IN_PAST: '/api/v1/npt/createInPast',
  DELETE_NPT: '/api/v1/npt/delete',
  DELETE_NPT_IN_PAST: '/api/v1/npt/deleteInPast',
  EDIT_NPT: '/api/v1/npt/edit',
  EDIT_NPT_IN_PAST: '/api/v1/npt/editInPast',
  GET_NPT_REASONS_LIST: '/api/v1/npt/reason/list',
  DELETE_NPT_REASON_SUBCATEGORY: '/api/v1/npt/reason/delete',

  // attachment
  GET_ATTACHMENT_LIST: '/api/v1/attachments/list',
  DELETE_ATTACHMENT: '/api/v1/attachments/delete',
  UPDATE_ATTACHMENT: '/api/v1/attachments/update',
  PRINT_ATTACHMENT_QR_CODE: '/api/v1/attachments/updateQRStatus',
  GET_ATTACHMENT_APPROVAL_LIST: '/api/v1/attachments/repair/list',
  UPDATE_ATTACHMENT_BY_ACTION: '/api/v1/attachments/action',
  UPDATE_ATTACHMENT_APPROVAL_BY_ACTION: '/api/v1/attachments/repair/updateStatus',
  GET_ATTACMENT_DETAILS_BY_SERIAL_NUMBER: '/api/v1/attachments/details/:attachmentSerialNumber',

  // knowldge base
  KNOWLEDGE_BASE_QUESTION: '/api/v1/knowledgebase/ask',
  KNOWLEDGE_BASE_SUBMIT_FEEDBACK: '/api/v1/analytics/submitFeedback',

  // app updates
  GET_MIN_REQUIRED_APP_VERSION: '/api/v1/minimumAppVersion',

  // multi shift management
  GET_ALL_SHIFTS: '/api/v1/factoryShift/getAllShifts',
  GET_LINE_SHIFTS: '/api/v2/factoryShift/getLineShifts',
  ASSIGN_SHIFT_TO_LOCATIONS: '/api/v1/factoryShift/assignShift',
  CREATE_SHIFT_CATEGORY: '/api/v1/factoryShift/createShiftCategory',
  CREATE_SHIFT: '/api/v2/factoryShift/createShift',
  GET_SHIFT_CATEGORIES: '/api/v1/factoryShift/getShiftCategories',
  GET_FACTORY_TIME_ZONE: '/api/v1/factoryShift/getFactoryTimeZone',
};

@Injectable({
  providedIn: 'root',
})
export class MmEnvironmentService {
  #API_URL: string;
  #API_REPORTS_URL: string;

  constructor(@Inject('environment') envValues: TMachineMaintenanceEnvironmentVars) {
    this.#API_URL = envValues.protocol + envValues.service_host + envValues.machine_maintainance;
    this.#API_REPORTS_URL = envValues.protocol + envValues.reports_host + '/page-reports';
  }

  public getUrlFromEnv(arg: keyof typeof MachineMaintenanceEndPoints): string {
    return this.#API_URL + MachineMaintenanceEndPoints[arg];
  }

  public getReportsUrl() {
    return this.#API_REPORTS_URL;
  }
}
